import { useRef } from 'react';
import './sidenav-item-child.scss';

function SideNavItemChild({
    item,
    onClick
} : {
    item: any,
    onClick: (data: object, ref?: any) => void,
}) {
    const elRef = useRef<any>();

    return (
        <div className="sidenav-item-child" ref={elRef} onClick={() => onClick(item)}>
            <p className={`${item.disabled ? 'disabled' : ''}`}>
                {item.name}
                {item.disabled && <i className="fas fa-lock"></i>}
            </p>
        </div>
    )
}

export default SideNavItemChild;